import { LoaderFunctionArgs, Outlet } from 'react-router';
import invariant from 'tiny-invariant';

import { createBreadcrumbConfig } from 'DesignSystem/features/dynamic-breadcrumbs/dynamic-breadcrumbs.utils';
import { LogErrorBoundary } from 'components/Errors/LogErrorBoundary';
import { DetailSideBarPageLayout } from 'components/styled/PageLayouts/DetailSideBarPage';
import { MODULE_NAMES } from 'pages/resources/modules/modules.api';
import { queryClient } from 'utils/api';

import { prefCardDetailsQuery } from '../api';
import PagePrefCardActionContext from '../components/card-detail/action-context/page-pref-card-action-context';
import CardDetailSidebar from '../components/card-detail/side-bar/sidebar';
import { PrefCardsDetailsResponse } from '../types';

export async function loader({ params }: LoaderFunctionArgs) {
  const { cardId } = params;
  invariant(typeof cardId === 'string', 'cardId is required');
  const detailsQuery = prefCardDetailsQuery(cardId);
  const detailsQueryState = queryClient.getQueryState(detailsQuery.queryKey);
  const isInvalidated = detailsQueryState?.isInvalidated;

  const details = isInvalidated
    ? await queryClient.fetchQuery<PrefCardsDetailsResponse>(detailsQuery)
    : (queryClient.getQueryData<PrefCardsDetailsResponse>(detailsQuery.queryKey) ??
      (await queryClient.fetchQuery<PrefCardsDetailsResponse>(detailsQuery)));

  return {
    details,
    ...createBreadcrumbConfig({
      label: details.client_card_id || 'Card',
      module: MODULE_NAMES.PHYSICIAN_PREFERENCE_CARDS,
    }),
  };
}

export function Component() {
  return (
    <PagePrefCardActionContext>
      <DetailSideBarPageLayout
        contentContainerClassName="bg-background"
        content={<Outlet />}
        managerComponent={<CardDetailSidebar />}
      />
    </PagePrefCardActionContext>
  );
}
Component.displayName = 'PreferenceCardDetails';
export const ErrorBoundary = () => <LogErrorBoundary routeComponent="PreferenceCardDetails" />;
